import { Auth } from '@core/auth';

import {
    getSelectedBillingAdviserId,
    hasAdvancedFeePlansForInvestorValidation,
    resolveBillingContextAdviserAccount
} from '@packages/rate-plans/utils/investorBillingSubscriptionValidation';

import i18n from '@plugins/i18n';

import AdviserFeesOrExternalValidator from './AdviserFeesOrExternalValidator';
import BaseValidator from './BaseValidator';
import RequiredValidator from './RequiredValidator';

export class InvestorAdviserBillingValidator extends BaseValidator {
    static key = 'investorAdviserBilling';

    static hasAdvancedFeePlans(model = null) {
        return hasAdvancedFeePlansForInvestorValidation(model, Auth(), getSelectedBillingAdviserId());
    }

    static getBillingContextAdviserAccount(model = null) {
        return resolveBillingContextAdviserAccount(model, Auth(), getSelectedBillingAdviserId());
    }

    static getAdviserRatePlanId(model = null) {
        return InvestorAdviserBillingValidator.getBillingContextAdviserAccount(model)?.adviser_rate_plan_id || null;
    }

    static getBillingGroupId(model = null) {
        return InvestorAdviserBillingValidator.getBillingContextAdviserAccount(model)?.billing_group_id || null;
    }

    /**
     * Valid when advanced fee plans are enabled and billing_group_id or
     * adviser_rate_plan_id is set on the scoped adviser account, or when legacy
     * intermediary fee fields satisfy adviserFeesOrExternal rules.
     */
    static validator(
        adviserFeesAgreedExternally = null,
        feePercentageOfInvestment = null,
        feeAmountPerAnnum = null,
        model = null
    ) {
        if (InvestorAdviserBillingValidator.hasAdvancedFeePlans(model)) {
            const billingGroupId = InvestorAdviserBillingValidator.getBillingGroupId(model);
            const adviserRatePlanId = InvestorAdviserBillingValidator.getAdviserRatePlanId(model);

            if (billingGroupId) {
                return true;
            }

            return RequiredValidator.validator(adviserRatePlanId, 'Adviser ongoing fee plan') === true
                ? true
                : i18n.t('validator.adviser_rate_plan_required');
        }

        return AdviserFeesOrExternalValidator.validator(
            adviserFeesAgreedExternally,
            feePercentageOfInvestment,
            feeAmountPerAnnum
        );
    }

    static arguments() {
        return [];
    }
}

export default InvestorAdviserBillingValidator;
